export default "__VITE_ASSET__Coxj6LWf__";